import React from "react";
import { PlaneTakeoff, Clock, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/accueil/Navbar";
import Footer from "../components/accueil/Footer";
import ChatWidget from "../components/accueil/ChatWidget";
import BackToTop from "../components/accueil/BackToTop";
import PageBanner from "./Banner";
import useGlobale from "../components/global";

const FormOut = () => {
  const navigate = useNavigate();
  const { authenticated, user, logout } = useGlobale();

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <Navbar authenticated={authenticated} user={user} logout={logout} />

      <PageBanner
        currentPage="Sortir du Niger"
        title="Sortir du Niger"
        subtitle="Procédures de sortie et documents nécessaires pour quitter le territoire."
        icon={<PlaneTakeoff className="w-6 h-6" />}
      />

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10" />
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-3">
            Bientôt disponible
          </h2>
          <p className="text-slate-600 mb-8 leading-relaxed">
            Le formulaire de déclaration de sortie du Niger est en cours de
            développement. Revenez prochainement pour soumettre votre demande
            en ligne.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 bg-white border border-slate-200 text-slate-700 px-5 py-2.5 rounded-lg font-semibold hover:bg-slate-50 transition-colors"
            >
              <ArrowLeft size={16} /> Retour
            </button>
            <button
              onClick={() => navigate("/procedure")}
              className="inline-flex items-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-colors"
            >
              Voir les procédures
            </button>
          </div>
        </div>
      </section>

      <Footer />
      <ChatWidget />
      <BackToTop />
    </div>
  );
};

export default FormOut;
